<template>
	<span>
	</span>
</template>
<script>
import rundownItemsApi from '@/api/rundownItems';

export default {
	name: 'ElementCustomCommand',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	components: {},
	data() {
		return {
			isCancel: false,
		};
	},
	sockets: {},
	computed: {
		content() {
			return this.item.content && this.item.content !== ''
				? JSON.parse(this.item.content) : {};
		},
	},
	methods: {
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
		stopAll() {
			const callback = () => {
				// const data = response.data;
				// executeCallbackOnce++; // stop next execution
			};
			const errorCallback = () => {
			};
			if (this.status === 'live') {
				if (this.content && this.content.onCompleteItem) {
					this.onCompletePlay(this.content.onCompleteItem);
				}
			}
			rundownItemsApi.stopAll(this.item.id, this.status, callback, errorCallback); // stop the lower third automatically
		},
		stringToSeconds(sec) {
			const hms = sec; // your input string
			const a = hms.split(':'); // split it at the colons
			// eslint-disable-next-line no-restricted-globals
			const first = isNaN((+a[0]) * 60 * 60) ? 0 : (+a[0]) * 60 * 60;
			// eslint-disable-next-line no-restricted-globals
			const second = isNaN((+a[1]) * 60 * 60) ? 0 : (+a[1]) * 60;
			// eslint-disable-next-line no-restricted-globals
			const third = isNaN((+a[2])) ? 0 : (+a[2]);
			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			const seconds = first + second + third;
			return seconds;
		},
	},
	watch: {},
	mounted() {},
	created() {
		if (this.content && this.content.duration) {
			const duration = this.stringToSeconds(this.content.duration);
			if (duration > 0) {
				setTimeout(() => {
					if (!this.isCancel) {
						this.stopAll();
					}
				}, duration * 1000);
			}
		}
	},
	destroyed() {},
	beforeDestroy() {
		this.isCancel = true;
	},
};
</script>
